module.exports = __webpack_public_path__ + "static/media/mum_standing.1de2ecde.png";